<template>
	<div>
		<v-app>
			<v-navigation-drawer app v-model="drawer" permanent>
				<v-list-item>
					<v-list-item-content>
						<v-list-item-title class="text-h6">
							진담헤어
						</v-list-item-title>
						<v-list-item-subtitle>
							jindamhair
						</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>

				<v-divider></v-divider>
				<v-list nav rounded style="text-align: left">
					<list-item
						v-for="(item, i) in menuItems"
						:key="i"
						:name="item.name"
						:icon="item.icon"
						:selectedMenu="selectedMenu"
						:index="i"
						@onClickList="selectedMenu = i"
						:style="selectedMenu == i ? 'background-color:' + $theme.primary : ''"
					></list-item>
				</v-list>
				<template v-slot:append>
					<v-btn block @click="logout()" :style="'background-color:#FFFFFF;color:' + $theme.primary" elevation="0">
						<v-icon>mdi-logout</v-icon>&nbsp;로그아웃
					</v-btn>
				</template>
			</v-navigation-drawer>
			<v-main :style="'background-color:' + $theme.lightBlue">
				<v-container fluid class="pa-3">
					<component :is="currentComponent" />
				</v-container>
			</v-main>
		</v-app>
	</div>
</template>

<script>
	import UserManager from '@/components/user/UserManager';
	import DesignerManager from '@/components/designer/DesignerManager';
	import StoreManager from '@/components/store/StoreManager';
	import BannerManager from '@/components/banner/BannerManager';
	import AlertManager from '@/components/alert/AlertManager';
	import MenuManager from '@/components/menu/MenuManager';
	import AppVersionManager from '@/components/app/AppVersionManager';
	import Settings from '@/templates/Settings';

	export default {
		name: 'HomePage',
		components: {
			UserManager,
			DesignerManager,
			StoreManager,
			BannerManager,
			AlertManager,
			MenuManager,
			Settings,
		},
		data: () => ({
			drawer: false,
			selectedMenu: 0, // 첫 번째 메뉴가 기본 선택됨
			menuItems: [
				{ name: '고객 관리', icon: 'mdi-account-box', component: UserManager },
				{ name: '디자이너 관리', icon: 'mdi-badge-account', component: DesignerManager },
				{ name: '헤어샵 관리', icon: 'mdi-office-building', component: StoreManager },
				{ name: '배너 관리', icon: 'mdi-view-carousel', component: BannerManager },
				{ name: '알림 관리', icon: 'mdi-bell', component: AlertManager },
				{ name: '시술 메뉴 관리', icon: 'mdi-menu', component: MenuManager },
				{ name: '앱 버전 관리', icon: 'mdi-cellphone-cog', component: AppVersionManager },
				{ name: '관리자 비밀번호 변경', icon: 'mdi-cog', component: Settings },
			],
		}),
		computed: {
			currentComponent() {
				return this.menuItems[this.selectedMenu].component;
			},
		},
		methods: {
			async logout() {
				await this.$auth.logout();
				this.$router.push('/');
			},
		},
	};
</script>

<style scoped></style>
